import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';
import { emailVerified } from '@angular/fire/auth-guard';

export const redirectUnverifiedToAuth = () => redirectUnverifiedTo(['auth']);
export const redirectUnverifiedTo = (redirect: any[]) =>
  pipe(
    emailVerified,
    map((verified) => verified || redirect)
  );

export const redirectVerifiedToHome = () => redirectVerifiedTo(['home']);
export const redirectVerifiedTo = (redirect: any[]) =>
  pipe(
    emailVerified,
    map((verified) => (verified && redirect) || true)
  );
